import React from 'react';
import { path } from 'ramda';
import { usePortletSelector } from 'js/components/system/Portlet';
import { CashierForm } from './components/CashierForm';
import withDeposit from './withDeposit';

export const methodsWithCustomTemplates = {};

export const Factory = (props) => {
    const { code } = usePortletSelector(path(['method', 'code']));
    const PaymentMethod = methodsWithCustomTemplates[code] || CashierForm;

    return <PaymentMethod {...props} />;
};

export default withDeposit(Factory);
